import _asyncToGenerator from "C:/Users/Administrator/Desktop/shujukeshihuaqianduan/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { onMounted, nextTick, ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import * as echarts from 'echarts';
import 'echarts/extension/bmap/bmap.js';
import TooltipHtml from './scatterMap/TooltipHtml';
import setOptions from './scatterMap/setOptions';
import { useRouter } from 'vue-router';
import MapControl from './MapControl';
import getBMap from '@/utils/baiduMap.js';

var getDeviceList = function getDeviceList() {
  // 设备列表
  var store = useStore();
  var deviceList = computed(function () {
    return store.state.device.deviceList;
  }); // 设备列表数据

  return {
    deviceList: deviceList
  };
};

var drawScatterMap = function drawScatterMap(deviceList) {
  // 绘制散点图
  var router = useRouter();
  var chartDom = ref(null); // 地图DOM

  var chartInstance = ref(null); // 地图实例

  var mapControlDom = ref(null); // 地图上的按钮DOM

  var tooltipFormatter = function tooltipFormatter(res) {
    // 设置地图属性
    var id = res.data.id;
    nextTick(function () {
      // // 点击地图上的散点后，监听"查看详情"点击事件
      var tooltipDom = document.getElementById('tooltipDom');
      tooltipDom.addEventListener('click', function () {
        // 查看设备详情
        var _router$resolve = router.resolve({
          path: '/deviceDetail',
          query: {
            id: id
          }
        }),
            href = _router$resolve.href;

        window.open(href, '_blank');
      });
    });
    return TooltipHtml(res.data);
  };

  var updateChart = function updateChart() {
    // 更新散点图数据
    var options = setOptions();
    options.tooltip.formatter = tooltipFormatter;
    chartInstance.value = echarts.init(chartDom.value);
    chartInstance.value.setOption(options);
    var bmap = chartInstance.value.getModel().getComponent('bmap').getBMap();
    mapControlDom.value.createButton(bmap); // 点击设备，显示选择设备的 tooltip
    // watch(() => store.state.device.chooseDeviceID, val => {
    //   const info = store.state.device.deviceList.find(item => item.id === val)
    //   myChart.dispatchAction({ type: 'showTip', seriesIndex: 0, name: info.name })
    // })
  };

  return {
    chartDom: chartDom,
    mapControlDom: mapControlDom,
    chartInstance: chartInstance,
    tooltipFormatter: tooltipFormatter,
    updateChart: updateChart
  };
};

export default {
  name: 'ScatterMap',
  components: {
    MapControl: MapControl
  },
  setup: function setup() {
    var _getDeviceList = getDeviceList(),
        deviceList = _getDeviceList.deviceList;

    var _drawScatterMap = drawScatterMap(deviceList),
        chartDom = _drawScatterMap.chartDom,
        mapControlDom = _drawScatterMap.mapControlDom,
        chartInstance = _drawScatterMap.chartInstance,
        tooltipFormatter = _drawScatterMap.tooltipFormatter,
        updateChart = _drawScatterMap.updateChart;

    watch(function () {
      return deviceList.value;
    }, function () {
      // 监听可查看设备的改变(例如登录账号后)，重新渲染地图
      var options = setOptions();
      options.tooltip.formatter = tooltipFormatter;
      chartInstance.value.setOption(options);
    });
    onMounted(function () {
      nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getBMap();

              case 2:
                // 创建地图的全局对象后再绘制地图
                updateChart();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    });
    return {
      chartDom: chartDom,
      mapControlDom: mapControlDom
    };
  }
};